module.exports = __webpack_public_path__ + "static/img/AU@2x.d180b645.jpg";